import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';

interface RarityStats {
  total: number;
  collected: number;
  percentage: number;
}

interface SetRarityStats {
  [rarity: string]: RarityStats;
}

export function useSetRarityStats(setCode: string | undefined) {
  const [stats, setStats] = useState<SetRarityStats>({});
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const fetchStats = async () => {
      if (!setCode || !user) {
        setStats({});
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .rpc('get_set_stats', {
            set_code: setCode,
            user_id: user.id
          });

        if (error) throw error;

        // Transform rarity_stats into our format
        const rarityStats: SetRarityStats = {};
        if (data?.rarity_stats) {
          Object.entries(data.rarity_stats).forEach(([rarity, stats]: [string, any]) => {
            rarityStats[rarity] = {
              total: stats.total,
              collected: stats.collected,
              percentage: stats.total > 0 ? (stats.collected / stats.total) * 100 : 0
            };
          });
        }

        setStats(rarityStats);
      } catch (err) {
        console.error('Error fetching set rarity stats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [setCode, user?.id]);

  return { stats, loading };
}